"use client"

import { motion, useReducedMotion } from "framer-motion"
import { MarketingCreateEventCta } from "@/components/marketing/marketing-create-event-cta"

const easeOut = [0.22, 1, 0.36, 1] as const

export function MarketingFinalCta() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="w-full min-w-0 border-t border-border/40 py-24 sm:py-32">
      <motion.div
        className="mx-auto max-w-[72rem] text-center"
        initial={reduceMotion ? false : { opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: reduceMotion ? 0 : 0.6, ease: easeOut }}
      >
        <h2 className="type-display-title mx-auto max-w-[18ch] text-balance text-[clamp(2.3rem,5.6vw,4.6rem)] leading-[1.08] tracking-[-0.02em]">
          Begin with one evening. Watch it become a thread.
        </h2>
        <div className="mt-9 flex justify-center sm:mt-10">
          <MarketingCreateEventCta className="h-11 rounded-full px-8" />
        </div>
      </motion.div>
    </section>
  )
}
